import { styled } from '@linaria/react'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const AccountInfoSC = styled.div<{
  rowGap?: FIXED_INDENTS
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  row-gap: ${({ rowGap }) => `var(${rowGap})`};
  background-color: var(${COLOR.SURFACE_DARK_2});
  border-radius: 8px;

  padding: var(${FIXED_INDENTS.INDENT_60});

  ${MEDIA.MAX_599} {
    padding: var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MAX_375} {
    padding: var(${FIXED_INDENTS.INDENT_40});
  }
`
